import { encodeHex } from "../../utils/hex";
import { mkDepositDatum, mkRedeemDatum, mkSwapDatum } from "../contractData";
export function mkAmmOutputs(addrs, txMath, R) {
    return new AmmOutputsImpl(addrs, txMath, R);
}
class AmmOutputsImpl {
    constructor(addrs, txMath, R) {
        this.addrs = addrs;
        this.txMath = txMath;
        this.R = R;
    }
    deposit(req) {
        const data = encodeHex(mkDepositDatum(req, this.R).to_bytes());
        return {
            value: req.orderValue,
            addr: this.addrs.ammDeposit,
            data
        };
    }
    redeem(req) {
        const data = encodeHex(mkRedeemDatum(req, this.R).to_bytes());
        return {
            value: req.orderValue,
            addr: this.addrs.ammRedeem,
            data
        };
    }
    swap(req) {
        const data = encodeHex(mkSwapDatum(req, this.R).to_bytes());
        return {
            value: req.orderValue,
            addr: this.addrs.ammSwap,
            data
        };
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYW1tT3V0cHV0cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9hbW0vaW50ZXJwcmV0ZXJzL2FtbU91dHB1dHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsT0FBTyxFQUFDLFNBQVMsRUFBQyxNQUFNLGlCQUFpQixDQUFBO0FBRXpDLE9BQU8sRUFBQyxjQUFjLEVBQUUsYUFBYSxFQUFFLFdBQVcsRUFBQyxNQUFNLGlCQUFpQixDQUFBO0FBWTFFLE1BQU0sVUFBVSxZQUFZLENBQUMsS0FBaUIsRUFBRSxNQUFjLEVBQUUsQ0FBYztJQUM1RSxPQUFPLElBQUksY0FBYyxDQUFDLEtBQUssRUFBRSxNQUFNLEVBQUUsQ0FBQyxDQUFDLENBQUE7QUFDN0MsQ0FBQztBQUVELE1BQU0sY0FBYztJQUNsQixZQUNrQixLQUFpQixFQUNqQixNQUFjLEVBQ2QsQ0FBYztRQUZkLFVBQUssR0FBTCxLQUFLLENBQVk7UUFDakIsV0FBTSxHQUFOLE1BQU0sQ0FBUTtRQUNkLE1BQUMsR0FBRCxDQUFDLENBQWE7SUFDN0IsQ0FBQztJQUVKLE9BQU8sQ0FBQyxHQUFtQjtRQUN6QixNQUFNLElBQUksR0FBRyxTQUFTLENBQUMsY0FBYyxDQUFDLEdBQUcsRUFBRSxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUMsUUFBUSxFQUFFLENBQUMsQ0FBQTtRQUM5RCxPQUFPO1lBQ0wsS0FBSyxFQUFFLEdBQUcsQ0FBQyxVQUFVO1lBQ3JCLElBQUksRUFBRSxJQUFJLENBQUMsS0FBSyxDQUFDLFVBQVU7WUFDM0IsSUFBSTtTQUNMLENBQUE7SUFDSCxDQUFDO0lBRUQsTUFBTSxDQUFDLEdBQWtCO1FBQ3ZCLE1BQU0sSUFBSSxHQUFHLFNBQVMsQ0FBQyxhQUFhLENBQUMsR0FBRyxFQUFFLElBQUksQ0FBQyxDQUFDLENBQUMsQ0FBQyxRQUFRLEVBQUUsQ0FBQyxDQUFBO1FBQzdELE9BQU87WUFDTCxLQUFLLEVBQUUsR0FBRyxDQUFDLFVBQVU7WUFDckIsSUFBSSxFQUFFLElBQUksQ0FBQyxLQUFLLENBQUMsU0FBUztZQUMxQixJQUFJO1NBQ0wsQ0FBQTtJQUNILENBQUM7SUFFRCxJQUFJLENBQUMsR0FBZ0I7UUFDbkIsTUFBTSxJQUFJLEdBQUcsU0FBUyxDQUFDLFdBQVcsQ0FBQyxHQUFHLEVBQUUsSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDLFFBQVEsRUFBRSxDQUFDLENBQUE7UUFDM0QsT0FBTztZQUNMLEtBQUssRUFBRSxHQUFHLENBQUMsVUFBVTtZQUNyQixJQUFJLEVBQUUsSUFBSSxDQUFDLEtBQUssQ0FBQyxPQUFPO1lBQ3hCLElBQUk7U0FDTCxDQUFBO0lBQ0gsQ0FBQztDQUNGIn0=